// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xGrG","rootMobile":"styles_rootMobile__2KntO"};